import request from "@/plugins/axios/courseApi.js";
import uaApirequest from "@/plugins/axios/api.js";
import utestRequest from "@/plugins/axios/utestApi.js";

// 创建图谱
export function createKnowledgeGraph (data) {
  return request({
    url: `/knowledgeGraph?graphName=${data.graphName}`,
    method: 'post',
    data
  })
}
// 删除图谱
export function delKnowledgeGraph (data) {
  return request({
    url: `/knowledgeGraph?graphId=${data.graphId}`,
    method: 'delete',
    data
  })
}
// 移动模块
export function moveModule (data, graphId) {
  return request({
    url: `/knowledgeModule/moveModule?graphId=${graphId}`,
    method: 'post',
    data
  })
}
// 模块选择知识点保存
export function moduleRelationKnowledge (data, moduleId) {
  return request({
    url: `/knowledgeModule/moduleRelationKnowledge?moduleId=${moduleId}`,
    method: 'post',
    data
  })
}
// 根据图谱id查询课程模块框架列表
export function getKnowledgeModuleList (params) {
  return request({
    url: `/knowledgeModule/list`,
    method: 'get',
    params
  })
}
// 删除模块
export function delKnowledgeModule (data) {
  return request({
    url: `/knowledgeModule?id=${data.id}`,
    method: 'delete',
    data
  })
}
// 创建或修改模块信息
export function createOrUpdateModule (data) {
  return request({
    url: `/knowledgeModule/createOrUpdateModule`,
    method: 'post',
    data
  })
}
// 根据图谱id查询知识点简单列表
export function getKnowledgeSimpleList (params) {
  return request({
    url: `/knowledge/simpleList`,
    method: 'get',
    params
  })
}
// 获取自己的图谱列表（通过创建人获取）
export function getKnowledgeGraph (params) {
  return request({
    url: `/knowledgeGraph/list`,
    method: 'get',
    params
  })
}
// 查询思政元素列表
export function ideologyElement (params) {
  return request({
    url: `/ideologyElement/list`,
    method: 'get',
    params
  })
}
// 手动创建知识点
export function creationKnowledge (data) {
  return request({
    url: `/knowledge`,
    method: 'post',
    data
  })
}
// 编辑知识点
export function putKnowledge (data) {
  return request({
    url: `/knowledge`,
    method: 'put',
    data
  })
}
// 删除知识点(批量)
export function delKnowledge (data) {
  return request({
    url: `/knowledge`,
    method: 'delete',
    data
  })
}
// 根据id查询知识点详情
export function getKnowledgeInfo (id, params) {
  return request({
    url: `/knowledge/${id}`,
    method: 'get',
    params
  })
}
// 移动知识点
export function moveKnowledge (data) {
  return request({
    url: `/knowledge/moveKnowledge`,
    method: 'post',
    data
  })
}
// 批量修改知识点属性
export function batchUpdateKnowledgeAttribute (data) {
  return request({
    url: `/knowledge/batchUpdateKnowledgeAttribute`,
    method: 'put',
    data
  })
}
// 课件导入、智能提取导入
export function coursewareImport (data,id) {
  return request({
    url: `/knowledge/coursewareImport?graphId=${id}`,
    method: 'post',
    data
  })
}
// 导入知识点
export function importKnowledge (data,id) {
  return request({
    url: `/knowledge/importKnowledge?graphId=${id}`,
    method: 'post',
    data
  })
}
// 下载知识点批量导入模板
export function knowledgeTemp () {
  return request({
    url: `/knowledge/knowledgeTemp`,
    method: 'get',
  })
}
// 根据图谱id查询知识点列表
export function getKnowledgeList (params) {
  return request({
    url: `/knowledge/list`,
    method: 'get',
    params
  })
}
// 智能提取（PDF、Word文档提取知识点）
export function wisdomExtract (data) {
  return request({
    url: `/knowledge/wisdomExtract`,
    method: 'post',
    data
  })
}
// 修改图谱名称
export function putKnowledgeName (data) {
  return request({
    url: `/knowledgeGraph`,
    method: 'put',
    data
  })
}
// 根据课件id查询知识图谱
export function getTextbookIdKnowledge (textbookId) {
  return request({
    url: `/knowledgeGraph/${textbookId}`,
    method: 'get',
  })
}
// 修改知识点名称
export function modifKnowledgeName (params) {
  return request({
    url: `/knowledgeRelation`,
    method: 'get',
    params
  })
}
// 设置知识点关系
export function knowledgeRelation (data) {
  return request({
    url: `/knowledgeRelation`,
    method: 'post',
    data
  })
}
// 查询知识点关系列表
export function getKnowledgeRelationList (id) {
  return request({
    url: `/knowledgeRelation/list/${id}`,
    method: 'get',
  })
}
// 取消试题关联
export function delQuestionRelation (id) {
  return request({
    url: `/questionRelation/${id}`,
    method: 'delete',
  })
}
// 题目批量关联知识
export function batchQuestionKnowledgeRelation (data) {
  return request({
    url: `/questionRelation/batchKnowledgeRelation`,
    method: 'post',
    data
  })
}
// 知识点批量关联题目
export function batchQuestionRelation (item) {
  let data = item.questionIds
  return request({
    url: `/questionRelation/batchQuestionRelation?knowledgeId=${item.knowledgeId}`,
    method: 'post',
    data
  })
}
// 根据知识点id查询关联试题列表
export function getQueListKnowledge (params) {
  return request({
    url: `/questionRelation/listByKnowledgeId`,
    method: 'get',
    params
  })
}
// 根据试题id查询关联知识点列表
export function listByQuestionId (params) {
  return request({
    url: `/questionRelation/listByQuestionId`,
    method: 'get',
    params
  })
}
// 取消资源关联
export function delResourceRelation (id) {
  return request({
    url: `/resourceRelation/${id}`,
    method: 'delete',
  })
}
// 资源批量关联知识点
export function batchResKnowledgeRelation (data) {
  return request({
    url: `/resourceRelation/batchKnowledgeRelation`,
    method: 'post',
    data
  })
}
// 知识点批量关联资源(单个、批量都可)
export function batchResourceRelation (item) {
  let data = item.resourceIds
  return request({
    url: `/resourceRelation/batchResourceRelation?knowledgeId=${item.knowledgeId}&resourceType=${item.resourceType}`,
    method: 'post',
    data
  })
}
// 根据知识点id查询关联资源列表
export function getResListKnowledge (params) {
  return request({
    url: `/resourceRelation/listByKnowledgeId`,
    method: 'get',
    params
  })
}
// 根据资源id查询关联知识点列表
export function listByResourceId (params) {
  return request({
    url: `/resourceRelation/listByResourceId`,
    method: 'get',
    params
  })
}
// 我的资源
export function getContentResList (params) {
  return request({
    url: `/content/user/list`,
    method: 'get',
    params
  })
}
// 根据课件id查询知识图谱
export function getGraphByTextbookId (params) {
  return request({
    url: `/knowledgeGraph/graphInfo`,
    method: 'get',
    params
  })
}

//根据图谱id查询知识图谱详情
export function getGraphByGraphId (params) {
  return request({
    url: `/knowledgeGraph/byGraphId`,
    method: 'get',
    params
  })
}


//修改图谱名称
export function saveKnowledgeGraphName (params) {
  return request({
    url: `/knowledgeGraph`,
    method: 'put',
    params
  })
}

//根据图谱id查询知识图谱详情
export function getGraphData (params) {
  return request({
    url: `/knowledgeGraph/relativeNetwork`,
    method: 'get',
    params
  })
}
// 查询ua资源、我的资源列表
export function getUaOrLibrary (params) {
  return request({
    url: `/resourceRelation/uaOrLibrary`,
    method: 'get',
    params
  })
}

//获取图谱列表
export function getKnowledgeGraphList (params) {
  return request({
    url: `/knowledgeGraph/byUserId`,
    method: 'get',
    params
  })
}

//获取图谱知识点列表
export function getGraphPoints (params) {
  return request({
    url: `/knowledge/list`,
    method: 'get',
    params
  })
}

//获取课件id查询课件关联的图谱知识点
export function getGraphPointsByTextbookId (params) {
  return request({
    url: `/knowledge/byTextbookId`,
    method: 'get',
    params
  })
}


//资源管理知识点 body:{knowledgeIds} query:{resourceId, resourceType}
export function saveResourceKnowledgePoints (params, data) {
  return request({
    url: `/resourceRelation/batchKnowledgeRelation`,
    method: 'post',
    params,
    data
  })
}
// 查询所有已关联的试题id
export function getAllQuestionIds (params) {
  return request({
    url: `/questionRelation/allQuestionIds`,
    method: 'get',
    params
  })
}
// 保存我的资源
export function seveUpload (data) {
  return request({
    url: `/course/content/upload`,
    method: 'post',
    data
  })
}
// 保存课件资源
export function resourcecallback (data) {
  return uaApirequest({
    url: `/qiniu/resourcecallback`,
    method: 'post',
    data
  })
}
// 课件章节
export function getTextbookDirectory (id) {
  return uaApirequest({
    url: `/course/${id}/directory`,
    method: 'get',
  })
}
// 课件题目
export function getTextbookQuelist (params) {
  return uaApirequest({
    url: '/question/textbookQuestionList',
    method: 'get',
    params
  })
}
// 我的题库
export function getMyQueList (params) {
  return utestRequest({
    url: '/question/getQuestions',
    method: 'get',
    params
  })
}
// 获取测验试题
export function getQuizList (params) {
  return request({
    url: '/questionRelation/quizList',
    method: 'get',
    params
  })
}
// 测验试题结果保存
export function quizResults (data) {
  return request({
    url: `/questionRelation/quizResults`,
    method: 'post',
    data
  })
}
// 获取题目详情
export function findQuestion (params) {
  return utestRequest({
    url: `/question/findQuestion`,
    method: 'get',
    params
  })
}
// 测验完成后的资源抽取
export function randomizing (params) {
  return request({
    url: `/resourceRelation/randomizing`,
    method: 'get',
    params
  })
}
// 获取历史问题及问答
export function getHistory(params) {
  return request({
    url: `/knowledge/questionAnswering/getHistory`,
    method: 'get',
    params: params
  })
}
// 你可能想问（三个）
export function possibleQuestion(params) {
  return request({
    url: `/knowledge/questionAnswering/possibleQuestion`,
    method: 'get',
    params: params
  })
}
// 图谱节点概况
export function nodeOverview(params) {
  return request({
    url: `/knowledgeGraph/nodeOverview`,
    method: 'get',
    params: params
  })
}
// 图谱教学资源概况
export function educationResources(params) {
  return request({
    url: `/knowledgeGraph/educationResources`,
    method: 'get',
    params: params
  })
}
// 知识点分布
export function knowledgeDistribute(params) {
  return request({
    url: `/knowledgeGraph/knowledgeDistribute`,
    method: 'get',
    params: params
  })
}

// 建立长连接
export function getConnection(code) {
  return utestRequest({
    url: `/fileUpload/getGoEasyOTP?code=${code}`,
    method: "get"
  });
}